import { observer } from 'mobx-react';
import * as style from './MetadataEntry.module.less';
import { Flex } from '@assets/component/UI/Flex/Flex';

interface IMetadataEntryProps {
    label: string;
    value: string;
}
export const MetadataEntry = observer((p: IMetadataEntryProps) => {
    return (
        <Flex direction="column" alignItems="start" className={style.container}>
            <div className={style.title}> {p.label} </div>
            <div className={style.value}>{p.value}</div>
        </Flex>
    );
});
